import { OverviewMenuItem } from 'types';
import { PERMISSIONS } from './permission';

export const settingsItems: OverviewMenuItem[] = [
  {
    id: '1',
    title: 'Quản Lý Danh Mục',
    description: 'Tất cả danh mục đều được quản lý tại trang này...',
    previewUrl: '/settings/categories?preview=true',
    navigateTo: '/settings/categories',
    permission: PERMISSIONS.CATEGORY,
  },
  {
    id: '2',
    title: 'Quản Lý Thương Hiệu',
    description: 'Tất cả thương hiệu đều được quản lý tại trang này...',
    previewUrl: '/settings/brands?preview=true',
    navigateTo: '/settings/brands',
    permission: PERMISSIONS.BRAND,
  },
  {
    id: '3',
    title: 'Quản Lý Đơn Vị',
    description: 'Tất cả đơn vị đều được quản lý tại trang này...',
    previewUrl: '/settings/units?preview=true',
    navigateTo: '/settings/units',
    permission: PERMISSIONS.UNIT,
  },
  {
    id: '4',
    title: 'Quản Lý Thuộc Tính',
    description: 'Tất cả thuộc tính đều được quản lý tại trang này...',
    previewUrl: '/settings/attributes?preview=true',
    navigateTo: '/settings/attributes',
    permission: PERMISSIONS.ATTRIBUTE,
  },
  {
    id: '5',
    title: 'Quản Lý Nhân Viên',
    description: 'Quản lý tất cả thông tin nhân viên trong hệ thống...',
    previewUrl: '/settings/staff?preview=true',
    navigateTo: '/settings/staff',
    permission: PERMISSIONS.STAFF,
  },
  {
    id: '6',
    title: 'Quản Lý Nguyên Liệu',
    description: 'Quản lý danh sách nguyên liệu và thông tin liên quan...',
    previewUrl: '/settings/materials?preview=true',
    navigateTo: '/settings/materials',
    permission: PERMISSIONS.MATERIAL,
  },
  {
    id: '7',
    title: 'Quản Lý Mã Giảm Giá',
    description: 'Thiết lập và quản lý các mã giảm giá cho khách hàng...',
    previewUrl: '/settings/discount-codes?preview=true',
    navigateTo: '/settings/discount-codes',
    permission: PERMISSIONS.DISCOUNT_CODE,
  },
  {
    id: '8',
    title: 'Quản Lý Hạng Thành Viên',
    description: 'Thiết lập các hạng thành viên và quyền lợi tương ứng...',
    previewUrl: '/settings/member-ranks?preview=true',
    navigateTo: '/settings/member-ranks',
    permission: PERMISSIONS.MEMBER_RANK,
  },
  {
    id: '9',
    title: 'Thông Tin Công Ty',
    description: 'Quản lý thông tin công ty của bạn...',
    previewUrl: '/settings/company-profile?preview=true',
    navigateTo: '/settings/company-profile',
    permission: PERMISSIONS.COMPANY_PROFILE,
  },
  {
    id: '10',
    title: 'Phân quyền hệ thống',
    description: 'Quản lý phân quyền hệ thống của bạn...',
    previewUrl: '/settings/system-permissions?preview=true',
    navigateTo: '/settings/system-permissions',
    permission: PERMISSIONS.PERMISSION,
  },
];
export const itemsItems = [
  {
    id: '1',
    title: 'Sản Phẩm',
    description: 'Tất cả sản phẩm đều được quản lý tại trang này...',
    previewUrl: '/items/products?preview=true',
    navigateTo: '/items/products',
    permission: PERMISSIONS.PRODUCT,
  },
];
export const invoiceItems: OverviewMenuItem[] = [
  {
    id: '1',
    title: 'Hoá Đơn Điện Tử',
    description: 'Tất cả hoá đơn điện tử đều được quản lý tại trang này...',
    previewUrl: '/invoices/electronic-invoices?preview=true',
    navigateTo: '/invoices/electronic-invoices',
    permission: PERMISSIONS.E_INVOICE,
  },
];
export const managementItems = [
  {
    id: '1',
    title: 'Quản Lý Phiếu Kiểm Kho',
    description: 'Tất cả phiếu kiểm kho đều được quản lý tại trang này...',
    previewUrl: '/management/inventory/check-orders?preview=true',
    navigateTo: '/management/inventory/check-orders',
    permission: PERMISSIONS.INVENTORY_CHECK_ODER,
  },
  {
    id: '2',
    title: 'Quản Lý Phiếu Xuất Kho',
    description: 'Tất cả phiếu xuất kho đều được quản lý tại trang này...',
    previewUrl: '/management/inventory/out-orders?preview=true',
    navigateTo: '/management/inventory/out-orders',
    permission: PERMISSIONS.STOCK_OUT_ORDER,
  },
  // {
  //   id: '2',
  //   title: 'Quản Lý Nhân Viên',
  //   description: 'Tất cả nhân viên đều được quản lý tại trang này...',
  //   previewUrl: '/employees?preview=true',
  //   navigateTo: '/employees',
  // },
  {
    id: '3',
    title: 'Quản Lý Đơn Hàng Bán Hàng',
    description: 'Tất cả đơn hàng bán hàng đều được quản lý tại trang này...',
    previewUrl: '/management/sale-orders?preview=true',
    navigateTo: '/management/sale-orders',
    permission: PERMISSIONS.SALE_ORDER,
  },
  {
    id: '4',
    title: 'Quản Lý Nhà Cung Cấp',
    description: 'Tất cả nhà cung cấp đều được quản lý tại trang này...',
    previewUrl: '/management/suppliers?preview=true',
    navigateTo: '/management/suppliers',
    permission: PERMISSIONS.SUPPLIER,
  },
  {
    id: '5',
    title: 'Quản Lý Phiếu Nhập Hàng',
    description: 'Phiếu nhập hàng đều được quản lý tại trang này...',
    previewUrl: '/management/inventory/purchase-orders?preview=true',
    navigateTo: '/management/inventory/purchase-orders',
    permission: PERMISSIONS.PURCHASE_ORDER,
  },
  {
    id: '6',
    title: 'Quản Lý Đơn Đặt Hàng Nhà Cung Cấp',
    description: 'Bạn có thể quản lý toàn bộ các đơn đặt hàng của bạn từ nhà cung cấp...',
    previewUrl: '/management/inventory/supplier-orders?preview=true',
    navigateTo: '/management/inventory/supplier-orders',
    permission: PERMISSIONS.ORDER_SUPPLIER,
  },
  {
    id: '7',
    title: 'Quản Lý Công Nợ',
    description: 'Tất cả công nợ đều được quản lý tại trang này...',
    previewUrl: '/management/debts?preview=true',
    navigateTo: '/management/debts',
    permission: PERMISSIONS.DEBT,
  },
  {
    id: '8',
    title: 'Quản Lý Khách Hàng',
    description: 'Tất cả khách hàng đều được quản lý tại trang này...',
    previewUrl: '/management/customers?preview=true',
    navigateTo: '/management/customers',
    permission: PERMISSIONS.CUSTOMER,
  },
];
